import { render } from "./CCAuthBadge.vue?vue&type=template&id=5a33dce6"
import script from "./CCAuthBadge.vue?vue&type=script&lang=js"
export * from "./CCAuthBadge.vue?vue&type=script&lang=js"

import "./CCAuthBadge.vue?vue&type=style&index=0&id=5a33dce6&less=less&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__